var map = {
	"./LV1.png": 78165,
	"./LV2.png": 92414,
	"./LV3.png": 80103,
	"./LV4.png": 88584,
	"./LV5.png": 28529,
	"./LV6.png": 20218,
	"./LV7.png": 25443,
	"./LV8.png": 81572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54165;